(function () {
  function mount(container) {
    if (!container || container.dataset.mounted === 'true') return;
    container.dataset.mounted = 'true';

    var output = container.querySelector('.aeliza-announcement__typed');
    var text = container.getAttribute('data-text') || '';
    if (!output) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      output.textContent = text;
      return;
    }

    var index = 0;

    function schedule(callback, delay) {
      window.setTimeout(function () {
        if (container.isConnected) callback();
      }, delay);
    }

    function begin() {
      output.textContent = '';
      index = 0;
      schedule(typeNext, 320);
    }

    function typeNext() {
      if (index < text.length) {
        output.textContent += text.charAt(index);
        index += 1;
        schedule(typeNext, 52);
        return;
      }

      schedule(begin, 2400);
    }

    begin();
  }

  function mountAll(root) {
    (root || document).querySelectorAll('[data-announcement-typewriter]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mountAll(document); });
  } else {
    mountAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { mountAll(event.target); });
})();
